import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OfwcaAddDialogData} from '../ofwca-add-dialog/ofwca-add-dialog.component';
import {Ofwca} from '../../../shared/interface/ofwca';
import {ReplaySubject} from 'rxjs';

export interface OfwcasListDialogData {
  ofwcas: Ofwca[];
}

@Component({
  selector: 'app-ofwcas-list-dialog',
  templateUrl: './ofwcas-list-dialog.component.html',
  styleUrls: ['./ofwcas-list-dialog.component.scss']
})
export class OfwcasListDialogComponent implements OnInit {
  ofwcasSubject: ReplaySubject<Ofwca[]> = new ReplaySubject<Ofwca[]>(1);

  constructor(
    public dialogRef: MatDialogRef<OfwcasListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OfwcasListDialogData
  ) {
    this.ofwcasSubject.next(data.ofwcas);
  }

  ngOnInit(): void {
  }

}
